<template>
    <div>
        <button
          type="button"
          class="btn btn-primary btn-with-addon mr-auto text-nowrap d-none d-md-block"
          @click="openModal()"
        >
          <span class="btn-addon">
            <i class="btn-addon-icon fe fe-plus-circle" />
          </span>
          Nieuwe Organisatie
        </button>
        <organization-modal :fetchOrganizations="()=>{this.fetchOrganizations()}" ref="addOrganizationModal"/>

    </div>
</template>

<script>
import OrganizationModal from './OrganizationModal.vue'
export default {
  props: ['fetchOrganizations'],
  components: {
    OrganizationModal,
  },
  data() {
    return {
      addOrganizationVisible: false,
      emptyOrganizationInformation: {
        name: undefined,
        departments_enabled: false,
        multiuser_enabled: false,
        zipcode: undefined,
        streetname_housenumber: undefined,
        coc_number: undefined,
        country: 'Nederland',
        city: undefined,
        invoice_email: undefined,
      },
      organizationInformation: undefined,
    }
  },
  methods: {
    openModal(organizationInformation = undefined) {
      this.$refs.addOrganizationModal.openModal(organizationInformation)
    },
  },
}
</script>
